import React from 'react';
import { Box, Container, Grid, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const serviceGroups = [
  {
    title: 'Spaces',
    items: [
      'False ceiling',
      'Modular kitchen',
      'Aluminium & stainless steel kitchen',
      'Premium wardrobes & furniture',
    ],
  },
  {
    title: 'Design',
    items: ['Space design', 'Elevation design', 'Floor plans'],
  },
  {
    title: 'Construction & Energy',
    items: ['Construction services', 'Solar energy solutions'],
  },
];

export default function ServicesSection() {
  const theme = useTheme();

  return (
    <Box id="services" component="section" sx={{ py: { xs: 8, md: 12 }, backgroundColor: 'transparent' }}>
      <Container>
        <Typography
          variant="overline"
          sx={{
            color: theme.palette.primary.main,
            letterSpacing: 3,
            mb: 2,
            display: 'block',
          }}
        >
          SERVICES
        </Typography>

        <Typography
          variant="h4"
          sx={{
            fontFamily: theme.typography.h1?.fontFamily,
            color: 'text.primary',
            mb: { xs: 4, md: 6 },
          }}
        >
          Elevated Solutions for Modern Spaces
        </Typography>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {serviceGroups.map((group, index) => (
            <Grid item xs={12} md={4} key={group.title}>
              <Box
                component="article"
                sx={{
                  minHeight: 260,
                  p: 4,
                  borderRadius: 3,
                  backgroundColor: 'rgba(18, 18, 18, 0.75)',
                  border: '1px solid rgba(229, 229, 229, 0.08)',
                  transition: 'transform 250ms ease, box-shadow 250ms ease, border-color 250ms ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 24px 60px rgba(197, 168, 128, 0.18)',
                    borderColor: 'rgba(197, 168, 128, 0.45)',
                  },
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily: theme.typography.h1?.fontFamily,
                    color: 'text.primary',
                    mb: 2,
                  }}
                >
                  {group.title}
                </Typography>

                <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                  {group.items.map((item) => (
                    <Box key={item} component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1.5 }}>
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          mt: '0.65rem',
                          borderRadius: '50%',
                          bgcolor: 'rgba(229, 229, 229, 0.75)',
                          flexShrink: 0,
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: theme.typography.fontFamily,
                          color: 'rgba(229, 229, 229, 0.88)',
                          lineHeight: 1.8,
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>

              {index < serviceGroups.length - 1 && (
                <Divider sx={{ display: { xs: 'block', md: 'none' }, my: 3, borderColor: 'rgba(255,255,255,0.08)' }} />
              )}
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
